import getMinimumZoomLevelForDestinations from './getMinimumZoomLevelForDestinations';
import { isDistrict } from './index';
import { IArea, IMappableSetting, ISetting } from 'types/map';

// Districts always have hitboxes (either for the whole district, or for their main destination);
// destinations only have hitboxes above the zoom threshold
export const shouldHaveHitbox = (area: IArea, setting: ISetting, zoomLevel: number) => {
  if (!setting.mapRootArea) {
    return false;
  }
  return isDistrict(area) || zoomLevel >= getMinimumZoomLevelForDestinations(setting as IMappableSetting);
};

export default shouldHaveHitbox;
